import { TrackingEvent } from '@tracking/gtag'

export type GACustomDimensions = {
    experiment_runs: string
    /**
     * 0: user is not logged-in
     * 1: user is logged-in
     */
    login_state: '0' | '1'
    lc_id: string
    lc_segment: string
    user_role: 'admin' | 'ambassador' | 'consul' | 'albatross' | 'basic' | ''
}

type PageViewEventParams = {
    page_title?: string // will default to document.title
    page_location?: string // will default to window.location
    page_path: string
}

/**
 * Manual pageviews
 * @see https://developers.google.com/analytics/devguides/collection/gtagjs/pages#manual_pageviews
 */
export const pageViewEvent = (eventParams: PageViewEventParams): TrackingEvent => ({
    eventName: 'page_view',
    eventParams,
})

export const socialMediaButtonTrackingEvent = (socialMedia: 'facebook' | 'whatsapp', link: string): TrackingEvent => ({
    eventName: 'social_media_button',
    eventParams: {
        event_category: socialMedia,
        event_label: link,
    },
})

export const communityExplorerTrackingEvent = (action: 'switch_community' | 'search' | 'back_home'): TrackingEvent => ({
    eventName: action,
    eventParams: {
        event_category: 'dialog',
        event_label: 'communities_explorer_dialog',
    },
})

export const messengerToggleTrackingEvent = (action: 'turn_on_categories' | 'turn_on_chat'): TrackingEvent => ({
    eventName: action,
    eventParams: {
        event_category: 'messenger',
        event_label: '',
    },
})

export const TRACKING_TYPE_REGISTRATION_STARTED: TTrackingEvent = 'REGISTRATION_STARTED'
export const TRACKING_TYPE_REGISTRATION_PHOTO_UPLOADED: TTrackingEvent = 'REGISTRATION_PHOTO_UPLOADED'

// Cockpit
export const TRACKING_TYPE_EVENT_COCKPIT_COCKPIT_VISITED: TTrackingEvent = 'EVENT_COCKPIT_COCKPIT_VISITED'

export const TRACKING_TYPE_GROUP_VIEWED: TTrackingEvent = 'GROUP_VIEWED'
export const TRACKING_TYPE_EVENT_VIEWED: TTrackingEvent = 'EVENT_VIEWED'

// Create Event
export const TRACKING_TYPE_EVENT_FORM_INTRODUCTION_STEP: TTrackingEvent = 'EVENT_FORM_INTRODUCTION_STEP'
export const TRACKING_TYPE_EVENT_FORM_LOCATION_STEP: TTrackingEvent = 'EVENT_FORM_LOCATION_STEP'
export const TRACKING_TYPE_EVENT_FORM_PHOTOS_STEP: TTrackingEvent = 'EVENT_FORM_PHOTOS_STEP'
export const TRACKING_TYPE_EVENT_FORM_COSTS_STEP: TTrackingEvent = 'EVENT_FORM_COSTS_STEP'
export const TRACKING_TYPE_EVENT_FORM_COHOST_PROMOTION_STEP: TTrackingEvent = 'EVENT_FORM_COHOST_PROMOTION_STEP'

export const TRACKING_TYPE_EVENT_EDIT_FORM: TTrackingEvent = 'EVENT_EDIT_FORM'
export const TRACKING_TYPE_EVENT_PREVIEW: TTrackingEvent = 'EVENT_PREVIEW'

// Group Request
export const TRACKING_TYPE_GROUP_REQUEST: TTrackingEvent = 'GROUP_REQUEST'
export const TRACKING_TYPE_GROUP_REQUEST_EDIT: TTrackingEvent = 'GROUP_REQUEST_EDIT'
export const TRACKING_TYPE_GROUP_REQUEST_REPLY: TTrackingEvent = 'GROUP_REQUEST_REPLY'
export const TRACKING_TYPE_GROUP_REQUEST_CONFIRMATION: TTrackingEvent = 'GROUP_REQUEST_CONFIRMATION'

export const TRACKING_TYPE_BROADCAST_INVITATION_SENT: TTrackingEvent = 'BROADCAST_INVITATION_SENT'

// custom SCA view tracking
export const TRACKING_TYPE_SCA_VIEWED: TTrackingEvent = 'SCA_VIEWED'
